module.exports = __webpack_public_path__ + "img/attach.3bd76899.svg";